export const ROUTE_ROOT = '/';
export const ROUTE_ROOT_PRIVATE = '/dashboard';

// AUTH
export const ROUTE_AUTH0_CALLBACK = '/auth0/callback';
export const ROUTE_RESET_PASSWORD = '/reset-password';
export const ROUTE_UPDATE_PASSWORD = '/reset-password/:token';
export const ROUTE_CREATE_PASSWORD = '/create-password/:token';

// DASHBOARD
export const ROUTE_OVERVIEW = '/overview';

// REPORTS
export const ROUTE_REPORTS = '/reports';
export const ROUTE_REPORT_DETAILS = '/reports/:report_id';

// SR REPORTS
export const ROUTE_SR_REPORTS = '/sr-reports';
export const ROUTE_SR_OVERVIEW = `${ROUTE_SR_REPORTS}/overview`;
export const ROUTE_SR_USERS = `${ROUTE_SR_REPORTS}/users`;
export const ROUTE_SR_USER_DETAILS = `${ROUTE_SR_USERS}/:user_id`;
export const ROUTE_SR_TRANSACTION = `${ROUTE_SR_REPORTS}/transaction`;
export const ROUTE_SR_TRANSACTION_OVERVIEW = `${ROUTE_SR_TRANSACTION}/overview`;
export const ROUTE_SR_REPORT = `${ROUTE_SR_REPORTS}/:slug`;

// USERS
export const ROUTE_USERS = '/users';

// PROFILES
export const ROUTE_PROFILES = '/profiles';

// SETTINGS
export const ROUTE_SETTINGS = '/settings';

// WEBHOOKS
export const ROUTE_WEBHOOKS = '/webhooks';

// STREAMING ADVICE
export const ROUTE_STREAMING_ADVICE = '/streaming-advise';

// WP
export const ROUTE_WP_PAGE = '/pages/:slug';

export const ROUTE_404 = '/404';
export const ROUTE_STYLEGUIDE = '/styleguide';

export const breadcrumbNameMap = {};

export const routes = [
  ROUTE_ROOT,
  ROUTE_ROOT_PRIVATE,
  ROUTE_AUTH0_CALLBACK,
  ROUTE_RESET_PASSWORD,
  ROUTE_UPDATE_PASSWORD,
  ROUTE_CREATE_PASSWORD,
  ROUTE_OVERVIEW,
  ROUTE_REPORTS,
  ROUTE_REPORT_DETAILS,
  ROUTE_SR_OVERVIEW,
  ROUTE_SR_USERS,
  ROUTE_SR_USER_DETAILS,
  ROUTE_SR_TRANSACTION_OVERVIEW,
  ROUTE_SR_REPORT,
  ROUTE_USERS,
  ROUTE_SETTINGS,
  ROUTE_WEBHOOKS,
  ROUTE_STREAMING_ADVICE,
  ROUTE_WP_PAGE,
  ROUTE_404,
  ROUTE_STYLEGUIDE,
];
